export default (fetch) => {
    return {
        // 获取验证码
        async sendCaptch(phone) {
            const {data} = await fetch.post('/arcopen/user/sms/sendsms', phone)
            if (data.code === 0) {
                return data.data
            } else {
                throw new Error(data.message)
            }
        }
    }
}
